module.exports = __webpack_public_path__ + "static/img/q7.661c583.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/q7.png
// module id = ejsl
// module chunks = 0